import React, { useState, useEffect } from "react";
import "./TutoringCountries.css";

import indiaFlag from "../assets/flags/india.png";
import unitedStatesFlag from "../assets/flags/united-states.png";
import australiaFlag from "../assets/flags/australia.png";
import uaeFlag from "../assets/flags/united-arab-emirates.png";
import newZealandFlag from "../assets/flags/new-zealand.png";
import ukFlag from "../assets/flags/united-kingdom.png";

const countries = [
  { id: 1, name: "India", imageSrc: indiaFlag, alt: "India flag" },
  {
    id: 2,
    name: "United States",
    imageSrc: unitedStatesFlag,
    alt: "United States flag",
  },
  {
    id: 3,
    name: "Australia",
    imageSrc: australiaFlag,
    alt: "Australia flag",
  },
  {
    id: 4,
    name: "United Arab Emirates",
    imageSrc: uaeFlag,
    alt: "United Arab Emirates flag",
  },
  {
    id: 5,
    name: "New Zealand",
    imageSrc: newZealandFlag,
    alt: "New Zealand flag",
  },
  {
    id: 6,
    name: "United Kingdom",
    imageSrc: ukFlag,
    alt: "United Kingdom flag",
  },
];

const FLAG_IMG_FALLBACK = (name) =>
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='120' height='80' viewBox='0 0 120 80'%3E%3Crect fill='%23F8F5F1' width='120' height='80' rx='10'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23666' font-size='11' font-family='sans-serif'%3E" +
  encodeURIComponent(name) +
  "%3C/text%3E%3C/svg%3E";

function TutoringCountries() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const update = () => setIsMobile(mq.matches);
    update();
    mq.addEventListener("change", update);
    return () => mq.removeEventListener("change", update);
  }, []);

  /* Mobile: smooth infinite scroll (duplicated row, no “3 per frame”) */
  const infiniteFlagRow = (
    <div className="tutoring-countries__flags-infinite" aria-hidden="true">
      <div className="tutoring-countries__flags-infinite-track">
        {[...countries, ...countries].map((country, index) => (
          <div key={`${country.id}-${index}`} className="tutoring-countries__flag">
            <img
              src={country.imageSrc}
              alt={country.alt}
              className="tutoring-countries__flag-img"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = FLAG_IMG_FALLBACK(country.name);
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );

  const flagRow = (
    <div className="tutoring-countries__flags">
      {countries.map((country) => (
        <div key={country.id} className="tutoring-countries__flag">
          <img
            src={country.imageSrc}
            alt={country.alt}
            className="tutoring-countries__flag-img"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = FLAG_IMG_FALLBACK(country.name);
            }}
          />
        </div>
      ))}
    </div>
  );

  return (
    <section
      className="tutoring-countries"
      aria-labelledby="tutoring-countries-heading"
    >
      <div className="tutoring-countries__content">
        <div className="tutoring-countries__header">
          <h2
            id="tutoring-countries-heading"
            className="tutoring-countries__heading"
          >
            One on One Private Online Tutoring Available in Your Country
          </h2>
        </div>

        <div className="tutoring-countries__flags-wrap">
          {isMobile ? infiniteFlagRow : flagRow}
        </div>
      </div>
    </section>
  );
}

export default TutoringCountries;
